"use client";

import Image from "next/image";

export default function DeliverArrest(data: any) {
  const {title, subtitle, description} = data;
  return (
    <div>
      <Image width={264} height={304} src={"/images/hour-glass.webp"} className="w-full max-w-[264px] h-auto" alt={"hour-glass"}/>
      {
        data &&
        <div className="text-center mb-[30px] lg:mb-0">
            <p className="h-[50px] text-[22px] text-[#001630] flex items-center justify-center mt-[24px]">{subtitle}</p>
            <div className="text-[42px] lg:text-[60px] font-bold text-[#0095EB] my-[24px]">{title}<span className="text-[24px] ml-[4px]">%</span></div>
            <p className="text-[18px] lg:text-[22px] text-[#001630]" dangerouslySetInnerHTML={{ __html: description }} />
        </div>
      }
    </div>
  );
}
